import { Row, Col } from "antd";
import SkeletonUI from "../Components/Skeletons";
import { Spacer } from "@nextui-org/react";
export const MockStoreData = [
  {
    id: 1,
    title: "a",
    products: [
      {
        id: 1,
      },
      {
        id: 2,
      },
      {
        id: 3,
      },
      {
        id: 4,
      },
    ],
  },
  {
    id: 2,
    title: "a",
    products: [
      {
        id: 1,
      },
      {
        id: 2,
      },
      {
        id: 3,
      },
      {
        id: 4,
      },
    ],
  },
];

export const StoreSkelton = () => {
  return (
    <Col span={24} className="mt-2">
      {MockStoreData.map((item, index) => (
        <Row key={index} gutter={[4, 4]}>
          {item?.products?.map((index) => (
            <Col lg={6} mg={8} xs={12} key={index}>
              <SkeletonUI cardId="mystore_card_skeleton" />
            </Col>
          ))}
        </Row>
      ))}
    </Col>
  );
};

export const ProductDetailsSkeleton = () => {
  return (
    <div>
      <div className="flex justify-between pt-4 px-4">
        <SkeletonUI
          cardId="button"
          noOfButtons={1}
          className="h-10 w-10 rounded"
        />
        <SkeletonUI
          cardId="button"
          noOfButtons={1}
          className="h-10 w-10 rounded"
        />
      </div>
      <div className="pt-14 h-full px-2">
        <SkeletonUI cardId="button" noOfButtons={1} className="h-44 rounded" />
        <Spacer y={4} />

        {["", "w-2/3", "w-1/2", "w-[20%]"].map((widthClass, index) => (
          <SkeletonUI
            key={index}
            cardId="heading"
            noOfLines={1}
            className={`pb-1 rounded-sm ${widthClass}`}
          />
        ))}

        <Spacer y={4} />

        <div className="flex space-x-2">
          <SkeletonUI cardId="button" noOfButtons={4} className="h-6 w-20" />
        </div>

        <Spacer y={6} />

        {["h-4 w-1/2", "h-4 my-4 w-1/2"].map((className, index) => (
          <div key={index} className="flex space-x-2">
            <SkeletonUI cardId="button" noOfButtons={2} className={className} />
          </div>
        ))}

        <Spacer y={4} />

        <div className="flex space-x-2">
          <SkeletonUI cardId="button" noOfButtons={2} className="h-10 w-24" />
        </div>

        <Spacer y={4} />

        <div className="flex space-x-2">
          <SkeletonUI
            cardId="button"
            noOfButtons={1}
            className="h-12 w-[80%]"
          />
          <SkeletonUI
            cardId="button"
            noOfButtons={1}
            className="h-12 w-[20%]"
          />
        </div>

        <Spacer y={4} />

        {Array(4)
          .fill(0)
          .map((_, index) => (
            <SkeletonUI
              key={index}
              cardId="heading"
              noOfLines={1}
              className="pb-0"
            />
          ))}
      </div>
    </div>
  );
};

export const TitleHeaderSkeleton = () => {
  return (
    <div className="flex px-2">
      <SkeletonUI cardId="button" noOfButtons={1} className={"w-[10%] h-10"} />
      <Spacer x={2} />
      <SkeletonUI cardId="button" noOfButtons={1} className={"w-[60%] h-10"} />
    </div>
  );
};

export const ButtonSliderShimmer = () => {
  return (
    <div className="flex space-x-2 w-full overflow-x-auto px-2 ">
      {["w-[80px]", "w-[60px]", "w-[50px]", "w-[60px]", "w-[60px]"].map(
        (item, index) => (
          <SkeletonUI
            cardId="button"
            noOfButtons={1}
            className={`${item} h-9 rounded-md`}
          />
        )
      )}
    </div>
  );
};
